// Spinner circular tier-aware. Em mid+ gira via CSS animation; em vlow/low
// fica estático (3 pontos pulsando OU bullet) pra não consumir GPU.
//
// Uso: <Spinner size="md" /> dentro de qualquer container.
// Pra tela inteira centralizada, use <LoadingScreen> (envolve este).

import { useTranslation } from '@app-iptv/i18n'
import styles from './Spinner.module.css'

interface SpinnerProps {
  /** Tamanho do spinner. sm=16px md=32px lg=48px. Default md. */
  size?: 'sm' | 'md' | 'lg'
  /** Cor (opcional, default brand-primary). */
  color?: string
  /** Texto descritivo pra leitor de tela. Default: `common.loading` no locale ativo. */
  label?: string
}

export function Spinner({ size = 'md', color, label }: SpinnerProps) {
  const { t } = useTranslation()
  return (
    <span
      role="status"
      aria-label={label ?? t('common.loading')}
      className={`${styles.spinner} ${styles[`size-${size}`] ?? ''}`}
      style={color ? { borderTopColor: color } : undefined}
    />
  )
}
